
  import { defineComponent, onMounted, ref, watch } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'
  import DocumentsTab from './documentsTab.vue'
  import Filters from './filtersCorporate.vue'

  export default defineComponent({
    components: {
      Filters,
      DocumentsTab
    },
    emits: ['on-selected'],
    setup() {
      const store = useStore()
      const route = useRoute()

      const selectedTab = ref(0)
      const filters = ref<any>({ search: '' })
      const resetFilters = (tab: number) => {
        filters.value = {}
      }
      const updateFilters = async (e: any, field = '') => {
        if (field === 'search') {
          store.dispatch('organizations/SEARCH_IN_DOCUMENTS', {
            query: e.search,
            companyId: route.params.id
          })

          return
        }

        store.commit('organizations/SET_DOCUMENTS_PAGINATION_PAGE', 1)

        filters.value = { ...e }

        if (filters.value?.contactsId?.length) {
          filters.value['contactsId'] = filters.value?.contactsId.reduce(
            (acc: string[], x: string) => {
              const v = x.split('@_')
              acc.push(...v)
              return acc
            },
            []
          )
        }
        await store.dispatch('organizations/GET_COMPANY_DOCUMENTS', {
          filter: { ...filters.value, limit: 20, offset: 0 },
          companyId: route.params.id
        })
      }

      watch(
        () => route.query?.type,
        (val) => {
          if (val == 'event') selectedTab.value = 0
        }
      )

      onMounted(() => {
        if (route.query?.type == 'event') selectedTab.value = 0

        store.commit('ui/DISPLAY_PREVIEW', false)
      })

      return {
        selectedTab,
        filters,
        updateFilters,
        resetFilters
      }
    }
  })
